import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {RibbonComponent} from './ribbon.component.';

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [RibbonComponent],
    providers: [],
    exports: [RibbonComponent]
})

export class RibbonModule {

}